import styles from './styles.module.scss';
import { ChartLegendItemCircle } from '../Charts/index.jsx';
import { ChartColorsMap } from '../Charts/constants/index.jsx';

const MetricChartHeader = ({ title, sensorName, sensorNameCompared, color, colorCompared, showDeep = false }) => {
  return (
    <div className={styles.metricChartHeader}>
      <h3 className={styles.metricChartTitle}>{title}</h3>

      {showDeep && <ChartLegendItemCircle value={`10 cm`} color={ChartColorsMap.soil} />}

      {sensorName && sensorNameCompared && (
        <ul className={styles.metricChartLegend}>
          <li style={{ color: color }}>
            <span>{sensorName}</span>
          </li>
          <li style={{ color: colorCompared }}>
            <span>{sensorNameCompared}</span>
          </li>
        </ul>
      )}
    </div>
  );
};

export default MetricChartHeader;
